var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"log-viewer"},[(_vm.logs === null)?_c('div',{staticClass:"noDataMessage"},[_c('i',{staticClass:"fas fa-spinner fa-spin fa-lg"}),_vm._v(" Loading logs...")]):_c('Logs',{attrs:{"logs":_vm.logs}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }